import { useState } from 'react'
import { Box } from '@mui/material'
import { Page } from 'Common/Page/Page'
import { PageHeader } from 'Common/Supplyvue-ui'
import { OptimiserSidebar } from './OptimiserSidebar'
import { OptimiserTable } from './OptimiserTable'
import { RunSolverPanel } from './RunSolverPanel'
import { RunHistoryPanel } from './RunHistoryPanel'
import { ScenarioSelector } from './ScenarioSelector'
import { ChartPanel } from './ChartPanel'
import { DEFAULT_SECTION, TableSection, findSection } from './Optimiser.sections'
import { TOKENS } from './OptimiserDesign'

const MainContent = ({
  section,
  scenarioId,
  onViewOutput,
}: {
  section: TableSection
  scenarioId: string | null
  onViewOutput: (runId: string, tableName: string) => void
}) => {
  if (section.type === 'run-solver') {
    return <RunSolverPanel scenarioId={scenarioId ?? undefined} onViewOutput={onViewOutput} />
  }
  if (section.type === 'run-history') {
    return <RunHistoryPanel scenarioId={scenarioId ?? undefined} onViewOutput={onViewOutput} />
  }
  if (section.type === 'chart') {
    return <ChartPanel section={section} scenarioId={scenarioId ?? undefined} />
  }
  return <OptimiserTable section={section} scenarioId={scenarioId ?? undefined} />
}

export const OptimiserPage = () => {
  const [selectedSection, setSelectedSection] = useState<TableSection>(DEFAULT_SECTION)
  const [scenarioId, setScenarioId] = useState<string | null>(null)

  const handleSelect = (id: string) => {
    const section = findSection(id) ?? DEFAULT_SECTION
    setSelectedSection(section)
  }

  const handleViewOutput = (runId: string, tableName: string) => {
    setSelectedSection({
      id: tableName,
      label: tableName.replace(/_/g, ' '),
      type: 'run-output',
      runId,
      scenarioId: scenarioId ?? undefined,
    })
  }

  return (
    <Page sx={{ padding: 0, flexDirection: 'column', overflow: 'hidden' }}>
      <Box sx={{ px: '36px', pt: '18px', flexShrink: 0 }}>
        <PageHeader title="Optimiser" />
      </Box>
      <ScenarioSelector scenarioId={scenarioId} onSelect={setScenarioId} />
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          overflow: 'hidden',
          borderTop: `1px solid ${TOKENS.line200}`,
          minHeight: 0,
        }}
      >
        <OptimiserSidebar
          selectedSection={selectedSection.id}
          onSelect={handleSelect}
        />
        <MainContent
          section={selectedSection}
          scenarioId={scenarioId}
          onViewOutput={handleViewOutput}
        />
      </Box>
    </Page>
  )
}
